import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import PropTypes from "prop-types";
import MKBox from "../../components/MKBox";
import MKTypography from "../../components/MKTypography";

const CircularProgressWithLabel = ({ progress }) => (
  <MKBox sx={{ position: "relative", display: "inline-flex" }}>
    <CircularProgress variant="determinate" value={progress} thickness={3} size={48} />
    <MKBox
      sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <MKTypography
        variant="body2"
        fontWeight="bold"
        component="div"
        color="primary"
      >{`${Math.round(progress)}%`}</MKTypography>
    </MKBox>
  </MKBox>
);

CircularProgressWithLabel.propTypes = {
  progress: PropTypes.number.isRequired,
};

export default CircularProgressWithLabel;
